import { breakpoints, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const MultiSelectWrapper = styled.div`
  margin: 8px 20px;
`;
export const BrandsMultiSelectWrapper = styled.div`
  margin: 0px 20px 8px;
`;

export const FooterWrapper = styled.div`
  box-shadow: 0px -1px 2px 0px rgba(71, 71, 71, 0.04),
    0px -2px 4px 0px rgba(71, 71, 71, 0.08);
`;

export const FooterButtonWrapper = styled.div`
  display: flex;
  button {
    flex: 1;
    margin: 16px 20px;
    @media (min-width: ${breakpoints.md}) {
      margin: 20px 20px 12px;
    }
  }
`;

export const DrawerSearchWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 16px 0 12px;
  background: ${theme.color.background.primary};

  input {
    ${theme.typography.labelRegular400}
    border-bottom-width: 1px !important;
    border-radius: 2px;
  }
`;

export const Letter = styled.div<{ isFirst: boolean }>`
  ${theme.typography.labelLarge}
  margin-bottom: 8px;
  margin-top: ${({ isFirst }) => (isFirst ? '8px' : '20px')};
`;
